import { Injectable, inject } from '@angular/core';
import {
  Firestore,
  CollectionReference,
  addDoc,
  collection,
  deleteDoc,
  doc,
  query,
  updateDoc,
  where,
} from 'firebase/firestore';
import { FirebaseService } from '../../_firebase/firebase.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Actualite } from '../../_interfaces/actualite';

@Injectable({
  providedIn: 'root'
})
export class ActualiteService {
  private firebase: FirebaseService = inject(FirebaseService);
  private firestore: Firestore = this.firebase.firestore;
  private actualitesCol: CollectionReference = collection(this.firestore, 'actualites');

  readPublishedActualites(): Observable<Actualite[]> {
    const publishedQuery = query(this.actualitesCol, where('statut', '==', 'publie'));
    return this.firebase.collectionData(publishedQuery, { idField: 'key' }).pipe(
      map(docs => (docs as Actualite[])
        .filter(actualite => new Date(actualite.date) <= new Date())
        .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
      )
    );
  }

  readAllActualites(): Observable<Actualite[]> {
    return this.firebase.collectionData(this.actualitesCol, { idField: 'key' }).pipe(
      map(docs => (docs as Actualite[])
        .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
      )
    );
  }

  createActualite(actualite: Actualite) {
    const { key, ...data } = actualite;
    return addDoc(this.actualitesCol, data);
  }

  updateActualite(id: string, actualite: Actualite) {
    const { key, ...data } = actualite;
    return updateDoc(doc(this.firestore, 'actualites', id), data);
  }

  deleteActualite(id: string) {
    return deleteDoc(doc(this.firestore, 'actualites', id));
  }

  readOneActualite(id: string): Promise<Actualite | null> {
    return this.firebase.getDoc(doc(this.firestore, 'actualites', id)).then(snapshot => {
      if (!snapshot.exists()) return null;
      return { key: snapshot.id, ...(snapshot.data() as Omit<Actualite, 'key'>) };
    });
  }
}
